import { newNotification } from "../../../store"

export function pushErrors(errors: BigCommerceError[]) {
    errors.forEach((error) => {
        let html
        if (error.__typename === "EmailAlreadyInUseError")
            html =
                "Diese Email-Adresse ist bereits in Verwendung. Bitte logge dich ein oder verwende eine andere Email-Adresse."
        newNotification({
            class: "error",
            html: html || error.message,
        })
    })
}
